import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  mainContainer: {
    flex: 1
  },
  container: {
    height: '98vh'
  }
}))
